import { render, staticRenderFns } from "./MultiAccount.vue?vue&type=template&id=453db98a"
import script from "./MultiAccount.vue?vue&type=script&lang=js"
export * from "./MultiAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports